import React, { useContext } from 'react'
import { multiCourse } from '@BUP/constants'
import { useTranslation } from 'react-i18next'
import HeaderDashboardSociogramResults from '../HeaderDashboardSociogramResults'
import CourseSelect from '@BUP/components/Generics/Selects/Courses'
import BupSpinner from '@BUP/components/Loading/Spinner'
import IndicatorDashboardResultsComponent from '../indicatorDashboardResultsComponent'
import NetworkComponent from '../networkComponent'
import WorkgroupDashboardContainer from '../workgroupDashboardContainer'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const DashboardComponents = ({
  name,
  filterPreAnalyticData,
  results,
  loading,
  courses,
  courseId,
  handleSelectCourse
}) => {
  const { type } = useContext(OrganizationContext)
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.dashBoardSociogram'
  })
  return (
    <div style={{ height: '100%' }}>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
        <HeaderDashboardSociogramResults
          name={name}
          results={results}
        />
        {type === multiCourse
          ? (
            <>
              <div style={{ display: 'flex', gap: 8, marginBottom: '1rem' }}>
                <p style={{ marginBottom: 0, alignSelf: 'center' }}>
                  Select a class:
                </p>
                <CourseSelect
                  filterCourses={courses}
                  onChange={handleSelectCourse}
                />
              </div>
              {loading
                ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: 200
                    }}
                  >
                    <BupSpinner
                      size='large'
                      tip={t('spinnerText')}
                    />
                  </div>
                  )
                : courseId
                  ? (
                    <>
                      <IndicatorDashboardResultsComponent
                        filterPreAnalyticData={filterPreAnalyticData}
                      />
                      <NetworkComponent
                        filterPreAnalyticData={filterPreAnalyticData}
                      />
                      <WorkgroupDashboardContainer results={results} />
                    </>
                    )
                  : null}
            </>
            )
          : (
            <>
              <IndicatorDashboardResultsComponent
                filterPreAnalyticData={filterPreAnalyticData}
              />
              <NetworkComponent filterPreAnalyticData={filterPreAnalyticData} />
              <WorkgroupDashboardContainer results={results} />
            </>
            )}
      </div>
    </div>
  )
}

export default DashboardComponents
